
<div #auth class="auth-container px-1 pb-5" data-bs-theme="light" [ngClass]="rootClassName">
  <ng-container [ngTemplateOutlet]="_header" [ngTemplateOutletContext]="{icon:'/assets/icons/popstudy-light.svg'}"></ng-container>
  @switch (state) {
    @case ('login') {
      <ng-container [ngTemplateOutlet]="_title" [ngTemplateOutletContext]="{title:'Log In to PopStudy'}"></ng-container>
      <div class="container px-1">
        <form
          class="container pb-3"
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit(loginForm)"
        >
          @if (isClassRoom()) {
            <p class="text-center text-secondary">Sign in with your PopSuite account to link with PopTeams.</p>
          }
          <ng-container [ngTemplateOutlet]="_formGroupEmail" [ngTemplateOutletContext]="{formGroup:loginForm}"></ng-container>
          <ng-container [ngTemplateOutlet]="_formGroupPassword" [ngTemplateOutletContext]="{formGroup:loginForm}"></ng-container>
        </form>

        <div class="row" [ngClass]="error(loginForm) ? 'mb-2':'mb-3'">
          <div class="col-12 text-center">
            <ng-container [ngTemplateOutlet]="_errorMessage" [ngTemplateOutletContext]="{form: loginForm}"></ng-container>
          </div>
        </div>

        <div class="d-flex flex-column row-gap-2 mb-3" [ngClass]="error(loginForm) ? 'mt-2':'mt-3'">
          <span class="container text-center mt-0">
            <ng-container [ngTemplateOutlet]="_submitButton" [ngTemplateOutletContext]="{form: loginForm, theme:'primary', label: getButtonLabel(loginForm)}"></ng-container>
          </span>
          <div class="text-center text-secondary pointer" (click)="onReset()">Forgot Password ?</div>
          <ng-container [ngTemplateOutlet]="_divider"></ng-container>
          <ng-container [ngTemplateOutlet]="_providers" [ngTemplateOutletContext]="{form: loginForm}"></ng-container>
        </div>
        <div class="row mt-2">
          <div class="col-12 text-center">
            <ng-container [ngTemplateOutlet]="_signupLinkButton" [ngTemplateOutletContext]="{form: loginForm, message: 'New to PopSuite ?', break: true, label: 'Create an account'}"></ng-container>
          </div>
        </div>
      </div>
    }
    @case ('register') {
      <ng-container [ngTemplateOutlet]="_title" [ngTemplateOutletContext]="{title:'Create An Account'}"></ng-container>
      <div class="container px-1">
        <form
          class="container pb-3"
          [formGroup]="registerForm"
          (ngSubmit)="onSubmit(registerForm)"
        >
          <p class="text-center text-secondary">Create an account to save lessons, track your progress, and unlock additional features.</p>
          <ng-container [ngTemplateOutlet]="_formGroupEmail" [ngTemplateOutletContext]="{formGroup:registerForm}"></ng-container>
          <div class="row">
            <div class="col">
              <ng-container [ngTemplateOutlet]="_formGroupFirstName" [ngTemplateOutletContext]="{formGroup:registerForm}"></ng-container>
            </div>
            <div class="col">
              <ng-container [ngTemplateOutlet]="_formGroupLastName" [ngTemplateOutletContext]="{formGroup:registerForm}"></ng-container>
            </div>
          </div>
          <ng-container [ngTemplateOutlet]="_formGroupPassword" [ngTemplateOutletContext]="{formGroup:registerForm}"></ng-container>
        </form>
        <div class="row" [ngClass]="error(registerForm) ? 'mb-2':'mb-3'">
          <div class="col-12 text-center">
            <ng-container [ngTemplateOutlet]="_termsPolicy" [ngTemplateOutletContext]="{form: registerForm, label: getButtonLabel(registerForm)}"></ng-container>
            <ng-container [ngTemplateOutlet]="_errorMessage" [ngTemplateOutletContext]="{form: registerForm}"></ng-container>
          </div>
        </div>
        <div class="d-flex flex-column row-gap-2 mb-3" [ngClass]="error(registerForm) ? 'mt-2':'mt-3'">
          <span class="container text-center mt-0">
            <ng-container [ngTemplateOutlet]="_submitButton" [ngTemplateOutletContext]="{form: registerForm, theme: 'primary', label: getButtonLabel(registerForm)}"></ng-container>
          </span>
          <span class="container text-center mt-0">
            <ng-container [ngTemplateOutlet]="_submitButton" [ngTemplateOutletContext]="{form: guestForm, theme: 'secondary', label: getButtonLabel(guestForm)}"></ng-container>
          </span>
          <ng-container [ngTemplateOutlet]="_divider"></ng-container>
          <ng-container [ngTemplateOutlet]="_providers" [ngTemplateOutletContext]="{form: registerForm}"></ng-container>
        </div>
      </div>
    }
    @case ('reset') {
      <ng-container [ngTemplateOutlet]="_title" [ngTemplateOutletContext]="{title:'Reset your password'}"></ng-container>
      <div class="container px-1">
        <form
          class="container pb-3"
          [formGroup]="resetForm"
          (ngSubmit)="onSubmit(resetForm)"
        >
          <span class="row text-center text-secondary">Enter your email address to receive instructions for resetting your password.</span>
          <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
            formGroup:resetForm,
            formControlName:'email',
            type: 'email',
            spellcheck: 'false',
            autocomplete: 'false',
            autocapitalize: 'false',
            placeholder:'Enter your email',
            description: 'a valid email address',
            label: 'Email'
          }"></ng-container>
        </form>
        <div class="row" [ngClass]="error(resetForm) ? 'mb-2':'mb-3'">
          <div class="col-12 text-center">
            <ng-container [ngTemplateOutlet]="_errorMessage" [ngTemplateOutletContext]="{form: resetForm}"></ng-container>
          </div>
        </div>

        <div class="d-flex flex-wrap justify-content-center gap-2 mb-3" [ngClass]="error(resetForm) ? 'mt-2':'mt-3'">
          <span class="container text-center mt-0">
            <ng-container [ngTemplateOutlet]="_submitButton" [ngTemplateOutletContext]="{form: resetForm, theme: 'primary', label: getButtonLabel(resetForm)}"></ng-container>
          </span>
          <span class="container text-center mt-0">
             <ng-container [ngTemplateOutlet]="_returnButton" [ngTemplateOutletContext]="{form: loginForm, label:'Return to Log In'}"></ng-container>
          </span>
        </div>
      </div>
    }
  }
</div>

<ng-template #_divider>
  <span class="container mb-1 text-divider">Or</span>
</ng-template>

<ng-template #_providers let-form="form">
  <span class="container text-center mt-0">
    <ng-container [ngTemplateOutlet]="_submitButton" [ngTemplateOutletContext]="{form, provider: 'google'}"></ng-container>
  </span>
  <span class="container text-center mt-0">
    <ng-container [ngTemplateOutlet]="_submitButton" [ngTemplateOutletContext]="{form, provider: 'apple'}"></ng-container>
  </span>
</ng-template>

<ng-template #_header
  let-text="text"
  let-icon="icon"
>
  @if(text) {
    <div class="modal-header border-0">
      <h3 class="modal-title mx-auto text-body headingboldmedium">PopStudy</h3>
      <ng-container [ngTemplateOutlet]="_closeButton" [ngTemplateOutletContext]="{className:'end-0 me-2'}"></ng-container>
    </div>
  } @else {
    <div class="mt-3">
      <ng-container [ngTemplateOutlet]="_closeButton" [ngTemplateOutletContext]="{className:'end-0 me-3'}"></ng-container>
      </div>
    <div class="modal-header border-0 mt-5">
      <img class="mx-auto image-fluid" [src]="icon"/>
    </div>
  }
</ng-template>

<ng-template #_title
  let-title="title"
>
  <div class="modal-header border-0">
    <h3 class="modal-title mx-auto text-body headingboldmedium">{{title}}</h3>
  </div>
</ng-template>

<ng-template #_formGroupInput
  let-formGroup="formGroup"
  let-formControlName="formControlName"
  let-type="type"
  let-placeholder="placeholder"
  let-description="description"
  let-spellcheck="spellcheck"
  let-autocorrect="autocorrect"
  let-autocomplete="autocomplete"
  let-autocapitalize="autocapitalize"
  let-visibility="visibility"
  let-class="class"
  let-requiredFeedback="requiredFeedback"
  let-invalidFeedback="invalidFeedback"
  let-label="label"
>
  <form class="input-group input-group-lg mb-3">
    <div class="form-floating border-0 border-bottom rounded-0 shadow-none bg-transparent" [formGroup]="formGroup">
      <input
        id="{{formControlName}}"
        [name]="placeholder"
        [type]="visibility === 'toggle' ? (masked ? 'password' : 'text') : type"
        [formControlName]="formControlName"
        [spellcheck]="spellcheck"
        [autocapitalize]="autocapitalize"
        [autocomplete]="autocomplete"
        [placeholder]="placeholder"
        class="form-control border-0 rounded-0 shadow-none bg-transparent pb-2 px-0 pt-5"
        [ngClass]="{'is-invalid': isInvalid(formGroup, formControlName)}"
        (keyup.enter)="onSubmit(formGroup)"
      >
      <label for="{{formControlName}}">{{label}}</label>
    </div>
    @if (visibility === 'toggle' && formGroup.get(formControlName).valid) {
      <span class="input-group-text icon border-0 border-bottom rounded-0 shadow-none bg-transparent">
        <mat-icon class="material-symbols-outlined" style="cursor: pointer" (click)="masked=!masked">{{masked ? 'visibility' : 'visibility_off'}}</mat-icon>
      </span>
    }
    @if (isInvalid(formGroup, formControlName)) {
      <div class="invalid-feedback">
        @if (isRequired(formGroup, formControlName)) { <span>{{requiredFeedback}}</span> }
      </div>
    }
  </form>
</ng-template>

<!-- Material version
<ng-template #_formGroupInput1
  let-formGroup="formGroup"
  let-formControlName="formControlName"
  let-type="type"
  let-placeholder="placeholder"
  let-description="description"
  let-spellcheck="spellcheck"
  let-autocorrect="autocorrect"
  let-autocomplete="autocomplete"
  let-autocapitalize="autocapitalize"
  let-visibility="visibility"
  let-class="class"
  let-requiredFeedback="requiredFeedback"
  let-invalidFeedback="invalidFeedback"
  let-label="label"
>
  <div [formGroup]="formGroup">
    <mat-form-field [floatLabel]="floatLabel()" [hideRequiredMarker]="hideRequired()">
      <mat-label>{{label}}</mat-label>
      <input
        matInput
        required="{{isRequired(formGroup, formControlName)}}"
        placeholder="{{placeholder}}"
        formControlName="{{formControlName}}"
        (blur)="updateErrorMessage()"
        (keyup.enter)="onSubmit(form)"
      />
      @if (code.invalid) {
        <mat-error>{{errorMessage()}}</mat-error>
      }
    </mat-form-field>
  </div>

  <mat-form-field class="input-group input-group-lg mb-3">
    <div class="form-floating border-0 border-bottom rounded-0 shadow-none bg-transparent" [formGroup]="formGroup">
      <input
        id="{{formControlName}}"
        [name]="placeholder"
        [type]="visibility === 'toggle' ? (hide ? 'password' : 'text') : type"
        [formControlName]="formControlName"
        [spellcheck]="spellcheck"
        [autocapitalize]="autocapitalize"
        [autocomplete]="autocomplete"
        [placeholder]="placeholder"
        class="form-control border-0 rounded-0 shadow-none bg-transparent pb-2 px-0 pt-5"
        [ngClass]="{'is-invalid': isInvalid(formGroup, formControlName)}"
        (keyup.enter)="onSubmit(formGroup)"
      >
      <label for="{{formControlName}}">{{label}}</label>
    </div>
    @if (visibility === 'toggle' && formGroup.get(formControlName).valid) {
      <span class="input-group-text icon border-0 border-bottom rounded-0 shadow-none bg-transparent">
        <mat-icon class="material-symbols-outlined" style="cursor: pointer" (click)="hide=!hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
      </span>
    }
    @if (isInvalid(formGroup, formControlName)) {
      <div class="invalid-feedback">
        @if (isRequired(formGroup, formControlName)) { <span>{{requiredFeedback}}</span> }
      </div>
    }
  </form>
</ng-template>
-->
<ng-template #_formGroupFirstLast let-formGroup="formGroup">
  <div class="input-group input-group-lg mb-3 form-floating">
    <input id="firstName" placeholder="First Name" type="text" aria-label="First name" class="form-control border-0 rounded-0 shadow-none bg-transparent pb-2 px-0 pt-5">
    <input id="lastName" placeholder="Last Name" type="text" aria-label="Last name" class="form-control border-0 rounded-0 shadow-none bg-transparent pb-2 px-0 pt-5">
    <label for="firstName">First Name</label>
    <label for="lastName">Last Name</label>
  </div>
</ng-template>

<ng-template #_formGroupFirstName let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'firstName',
    type:'text',
    spellcheck:'false',
    autocorrect:'false',
    autocomplete:'given-name',
    autocapitalize:'none',
    placeholder:'First Name',
    description:'a valid email address',
    requiredFeedback:'Please provide a first name.',
    invalidFeedback:'Please provide a first name.',
    label:'First Name',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupLastName let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'lastName',
    type:'text',
    spellcheck:'false',
    autocorrect:'false',
    autocomplete:'family-name',
    autocapitalize:'none',
    placeholder: 'Last Name',
    description:'a last name',
    requiredFeedback:'Please provide a last name.',
    invalidFeedback:'Please provide a last name.',
    label:'Last Name',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupProfile let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'profile',
    type:'text',
    spellcheck:'false',
    autocorrect:'false',
    autocomplete:'username',
    autocapitalize:'none',
    placeholder:'Enter your profile name',
    description:'a profile name',
    requiredFeedback:'Please provide a profile name.',
    invalidFeedback:'Please provide a profile name.',
    label:'Profile Name',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupEmail let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'email',
    type:'email',
    spellcheck:'false',
    autocorrect:'false',
    autocomplete:'email',
    autocapitalize:'none',
    placeholder:'Enter your email',
    requiredFeedback:'Please provide an email address.',
    invalidFeedback:'Must be a valid email address.',
    label:'Email',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupPassword let-formGroup="formGroup">
  <ng-container [ngTemplateOutlet]="_formGroupInput" [ngTemplateOutletContext]="{
    formGroup,
    formControlName:'password',
    type: 'password',
    spellcheck: 'false',
    autocorrect: 'false',
    autocomplete: 'false',
    autocapitalize: 'none',
    placeholder: 'Enter your password',
    visibility: 'toggle',
    requiredFeedback:'Please provide a password.',
    invalidFeedback: 'Must be at least 6 characters.',
    label:'Password',
  }"></ng-container>
</ng-template>

<ng-template #_formGroupReset let-formGroup="formGroup">
  <div class="mb-3" [formGroup]="formGroup">
    <div class="text-secondary" (click)="onReset()">Forgot Password?</div>
  </div>
</ng-template>

<ng-template #_closeButton let-className="className">
  <button
    type="button"
    class="btn btn-sm btn-close position-absolute {{className}}"
    aria-label="Close"
    (click)="onClose()"
  >
  </button>
</ng-template>

<ng-template #_guestButton
  let-form="form"
  let-label="label"
  let-fill="fill"
>
  <button
    type="button"
    class="btn btn-lg btn-custom guest"
    [disabled]="isSubmitted || form.invalid"
    (click)="isClassRoom() ? onLogin() : onSubmit(form)"
  >
    {{ label }}
  </button>
</ng-template>

<ng-template #_submitButton
  let-form="form"
  let-text="label"
  let-theme="theme"
  let-provider="provider"
>
  <nx-superprep-signin-button
    [provider]="provider"
    [text]="text"
    [size]="'full'"
    [theme]="theme"
    [disabled]="!provider && (isSubmitted || form.invalid)"
    (action)="onSubmit(form, provider)"
  ></nx-superprep-signin-button>
</ng-template>

<ng-template #_continueButton
  let-form="form"
  let-label="label"
>
  <button
    type="button"
    class="btn btn-lg btn-custom text-nowrap"
    [disabled]="isSubmitted || form.invalid"
    (click)="onContinue(form)"
  >
    {{ isSubmitted ? label.submitting : label.submit }}
  </button>
</ng-template>

<ng-template #_signupLinkButton
  let-form="form"
  let-message="message"
  let-label="label"
  let-break="break"
>
  <p class="text-secondary">
    @if (message) { <span>{{message}}</span> }@if (break){<br/>}<a class="text-secondary pointer" (click)="onRegister()">{{label}}</a>
  </p>
</ng-template>

<ng-template #_returnButton
  let-form="form"
  let-message="message"
  let-label="label"
  let-break="break"
>
  <p class="text-secondary">
    @if (message) { <span>{{message}}</span> }@if (break){<br/>}<a class="text-secondary pointer" (click)="onLogin()">{{label}}</a>
  </p>
</ng-template>

<ng-template #_errorMessage let-form="form">
  <div class="justify-content-center" [ngStyle]="{'color': error(form) ? 'red' : 'initial'}" [ngClass]="{'frame16pxspacer': !error(form) }">{{ errorMessage(form) }}</div>
</ng-template>

<ng-template #_termsPolicy let-form="form" let-label="label">
  <div class="text-secondary" [style.font-size]="'14px'">
    By clicking “{{label}}” you agree to the
    <br />
    <a class="text-secondary pointer" (click)="onDisplay('terms')">Terms &amp; Conditions</a>
    and <a class="text-secondary pointer" (click)="onDisplay('privacy')">Privacy Policy</a>.
    <br />
  </div>
</ng-template>
